import { ExcludeNil } from '@rbi-ctg/frontend';
import {
  INavigationButtonFragment,
  INavigationLinksFragment,
  INavigationSectionFragment,
  INavigationTabsFragment,
  useFeatureNavigationQuery,
} from 'generated/sanity-graphql';
import { useFeaturesContext } from 'state/features';

interface IUseFeatureNavigationValue {
  featureNavigationLoading: boolean;
  featureNavigationDesktop: ExcludeNil<INavigationLinksFragment['navigationLinks']>;
  featureNavigationMobile: ExcludeNil<INavigationTabsFragment['navigationTabs']>;
  featureAboutMenuEntriesDesktop: INavigationSectionFragment | null;
  featureAboutMenuEntriesMobile: INavigationSectionFragment | null;
  featureNavigationMobileHeaderButton: ExcludeNil<
    INavigationButtonFragment['navigationMobileHeaderButton']
  > | null;
}

export const useFeatureNavigation = (): IUseFeatureNavigationValue => {
  const { featureNavigationId = '', featureIdsLoading } = useFeaturesContext();

  const { data, loading } = useFeatureNavigationQuery({
    variables: { featureNavigationId },
    skip: !featureNavigationId,
  });

  const { navigationDesktop, navigationMobile, navigationMobileHeaderButton } =
    data?.FeatureNavigation ?? {};
  const featureNavigationLoading = featureIdsLoading || loading;

  return {
    featureNavigationDesktop: navigationDesktop?.navigationLinks ?? [],
    featureNavigationMobile: navigationMobile?.navigationTabs ?? [],
    featureAboutMenuEntriesDesktop: navigationDesktop?.aboutMenuEntries ?? null,
    featureAboutMenuEntriesMobile: navigationMobile?.aboutMenuEntries ?? null,
    featureNavigationMobileHeaderButton: navigationMobileHeaderButton ?? null,
    featureNavigationLoading,
  };
};
